import { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { OkrActivityI } from '~src/interfaces/okrActivity.interface';

import ActivityElement from './ActivityElement';

const fadeIn = keyframes`
  0% {
    margin-top: 100px;
    opacity: 0;
  }
  50% {
    margin-top: 100px;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
`;

const ListWrapper = styled.div`
  padding: 40px;
`;

const List = styled.div`
  animation: ${fadeIn} 350ms ease-in-out;
`;

const EmptyMessage = styled.div`
  margin: 30px 0;
  text-align: center;
`;

interface Props {
  activities: OkrActivityI[] | null;
}

const ActivityList: FC<Props> = props => {
  const [t] = useTranslation();
  return (
    <ListWrapper>
      {props.activities && props.activities.length > 0 ? (
        <List>
          {props.activities.map(activity => (
            <ActivityElement key={activity.id} activity={activity} />
          ))}
        </List>
      ) : (
        <EmptyMessage data-translation="okr.activities.empty.message">
          {t('okr.activities.empty.message')}
        </EmptyMessage>
      )}
    </ListWrapper>
  );
};

export default ActivityList;
